
;(function () {
  function init(root) {
    if (!root) return
    var sectionId = root.getAttribute('data-section-id')
    if (!sectionId) return

    var stickyBtn = root.querySelector('.ir-sticky-atc__btn')
    if (!stickyBtn) return
    var scrollOnly = stickyBtn.matches('a[href="#ir-pdp-buy"]')

    var mainSection = document.getElementById('MainProduct-' + sectionId)
    var submitBtn = mainSection
      ? mainSection.querySelector('#ProductSubmitButton-' + sectionId)
      : document.getElementById('ProductSubmitButton-' + sectionId)
    if (!submitBtn) return

    document.body.classList.add('ir-has-sticky-atc')

    var isMobile = !window.matchMedia || window.matchMedia('(max-width: 749px)').matches
    if (!isMobile) return

    var observeTarget = submitBtn

    function getLabelSource() {
      return (
        submitBtn.querySelector('.ir-panel-atc-btn__text') ||
        submitBtn.querySelector('span') ||
        submitBtn
      )
    }

    function syncState() {
      if (scrollOnly) return
      var isDisabled = submitBtn.hasAttribute('disabled')
      stickyBtn.toggleAttribute('disabled', isDisabled)

      var labelSource = getLabelSource()
      var nextText = (labelSource && labelSource.textContent ? labelSource.textContent : '').trim()
      var stickyTextEl = stickyBtn.querySelector('.ir-panel-atc-btn__text')
      if (stickyTextEl && nextText && stickyTextEl.textContent.trim() !== nextText) {
        stickyTextEl.textContent = nextText
      }

      var isLoading = submitBtn.classList.contains('loading')
      stickyBtn.classList.toggle('loading', isLoading)
      var spinner = stickyBtn.querySelector('.loading-overlay__spinner')
      if (spinner) spinner.classList.toggle('hidden', !isLoading)
    }

    function show() {
      if (!root.hasAttribute('hidden')) return
      root.removeAttribute('hidden')
      root.classList.add('is-visible')
      document.body.classList.add('ir-sticky-atc-visible')
    }

    function hide() {
      if (root.hasAttribute('hidden')) return
      root.setAttribute('hidden', '')
      root.classList.remove('is-visible')
      document.body.classList.remove('ir-sticky-atc-visible')
    }

    // 🔥 NEW: Detect cart drawer state
    function isCartDrawerOpen() {
      return !!document.querySelector(
        'cart-drawer[open], .cart-drawer.active, .drawer.active, .js-drawer-open'
      )
    }

    stickyBtn.addEventListener('click', function () {
      if (scrollOnly) return
      if (stickyBtn.hasAttribute('disabled')) return
      submitBtn.click()
    })

    syncState()

    try {
      new MutationObserver(function () {
        syncState()
      }).observe(submitBtn, { attributes: true, childList: true, subtree: true, characterData: true })
    } catch (e) {}

    if (!('IntersectionObserver' in window)) {
      show()
      return
    }

    var buttonsVisible = true
    var raf = 0

    function applyVisibility() {
      syncState()

      // 🔥 NEW: force hide if cart drawer is open
      if (isCartDrawerOpen()) {
        hide()
        return
      }

      if (buttonsVisible) {
        hide()
      } else {
        show()
      }
    }

    function scheduleApply() {
      if (raf) return
      raf = requestAnimationFrame(function () {
        raf = 0
        applyVisibility()
      })
    }

    var ioOpts = { root: null, rootMargin: '-64px 0px 0px 0px', threshold: 0 }

    var ioButtons = new IntersectionObserver(function (entries) {
      var e = entries[0]
      if (!e) return
      buttonsVisible = e.isIntersecting
      scheduleApply()
    }, ioOpts)
    ioButtons.observe(observeTarget)

    scheduleApply()

    // 🔥 NEW: fallback watcher (because Shopify themes are chaotic)
    setInterval(function () {
      applyVisibility()
    }, 300)

    if (window.matchMedia) {
      var mq = window.matchMedia('(max-width: 749px)')
      function onMq() {
        if (!mq.matches) {
          hide()
          document.body.classList.remove('ir-sticky-atc-visible')
        } else {
          scheduleApply()
        }
      }
      if (mq.addEventListener) mq.addEventListener('change', onMq)
      else mq.addListener(onMq)
    }
  }

  function boot() {
    document.querySelectorAll('.ir-sticky-atc[data-section-id]').forEach(function (el) {
      init(el)
    })
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot)
  else boot()
})()